import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18next';
import { useModals } from 'core/notifications';

import useVersions from '../hooks/useVersions';

import ListBody from './listBody';
import ListEmpty from './listEmpty';
import ListHeader from './listHeader';
import VersioningListItem from './versioningListItem';
import VersioningModal from './versioningModal';

import styles from '../styles/versioningList.module.scss';

const ListItem = ({ item, onClick }) => (
  <VersioningListItem item={item} onClick={onClick} />
);

const VersioningList = ({
  getComposeSchema = () => {},
  getPropertiesAxiosConfig = () => {},
  getPropertiesSchema = () => {},
  getVersionAxiosConfig = () => {},
  onVersionContent = () => {},
  queryParamsToPersist = [],
  versionsAxiosConfig = {},
}) => {
  const {
    isLoading,
    fetchVersions,
    versions,
  } = useVersions({ axiosConfig: versionsAxiosConfig });

  const { addModal } = useModals();

  const handleClick = (version) => {
    addModal({
      component: (
        <VersioningModal
          fetchVersions={fetchVersions}
          getComposeSchema={getComposeSchema}
          getPropertiesAxiosConfig={getPropertiesAxiosConfig}
          getPropertiesSchema={getPropertiesSchema}
          getVersionAxiosConfig={getVersionAxiosConfig}
          onVersionContent={onVersionContent}
          queryParamsToPersist={queryParamsToPersist}
          version={version}
        />
      ),
      hasCloseButton: true,
      id: 'versioning-modal',
      isFullScreen: true,
    });
  };

  return (
    <>
      <ListHeader
        columns={[i18n.t('date')]}
        hasTitleHeader={false}
        nameText={i18n.t('name')}
        rowClassName={styles.row}
      />
      <ListBody
        data={versions}
        emptyComponent={(
          <ListEmpty
            body={i18n.t('versioning-empty-body')}
            title={i18n.t('versioning-empty-title')}
          />
        )}
        isLoading={isLoading}
        isUngrouped
        ListItem={(props) => ListItem({ onClick: handleClick, ...props })}
      />
    </>
  );
};

VersioningList.propTypes = {
  getComposeSchema: PropTypes.func,
  getPropertiesAxiosConfig: PropTypes.func,
  getPropertiesSchema: PropTypes.func,
  getVersionAxiosConfig: PropTypes.func,
  onVersionContent: PropTypes.func,
  queryParamsToPersist: PropTypes.arrayOf(PropTypes.string),
  versionsAxiosConfig: PropTypes.shape({}),
};

export default React.memo(VersioningList);
